export default __webpack_public_path__ + "14eb5b9f72cbc47eff7f26d8574e7e54.otf";